<div class="char-count" [class.over-limit]="fieldLength > maxLength">
	<div>{{fieldLength}} / {{maxLength}} characters</div>
</div>
